import React from 'react';

const doctors = [
  {
    name: 'Dr. Sidharthi Selvaraj',
   role: 'Board certified in Internal Medicine & Obesity Medicine',
    image: '/public/SidDoctor.webp',
    description: 'Special interest in Womens Health, Geriatrics, and Obesity Medicine with over 12 years of experience.',
  },
  {
    name: 'Dr. Safrina Hasan',
    role: 'Board certified in Internal Medicine & Obesity Medicine',
    image: '/public/HasanDoctor.webp',
     description: 'Special interest in Primary care, Geriatrics, Obesity Medicine with over 18 years of experience.',
  },
   {
    name: 'Dr. Anugeet Kaur', 
    role: 'Board certified in Family Medicine & Obesity Medicine',
    image: '/AnuDoctor.jpg',
    description: 'Special interest in Primary Prevention, Obesity, Metabolic Syndrome and Geriatrics with over 15 years of experience.'
  },
]; 

export default function Team() {
  return (
    <div id="doctors" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">Our Doctors</h2>
          <p className="mt-4 text-xl text-gray-600">
            Expert healthcare providers dedicated to your well-being
          </p>
        </div>
        <div className="mt-20 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
          {/* Dr. Sidharthi's Card */}
          <div className="text-center">
            <div className="relative">
              <img
                className="mx-auto h-64 w-64 rounded-full object-cover"
                src="/SidDoctor.jpg"
                alt="Dr. Sidharthi"
              />
            </div>
            <div className="mt-6">
              <h3 className="text-xl font-medium text-gray-900">Dr. Sidharthi Selvaraj MD</h3>
              <p className="mt-2 font-medium text-blue-600">Board Certified in Internal Medicine & Obesity Medicine</p>
            </div>
          </div>

          {/* Dr. Hasan's Card */}
          <div className="text-center">
            <div className="relative">
              <img
                className="mx-auto h-64 w-64 rounded-full object-cover"
                src="/HasanDoctor.jpg"
                alt="Dr. Hasan"
              />
            </div>
            <div className="mt-6">
              <h3 className="text-xl font-medium text-gray-900">Dr. Safrina Hasan DO</h3>
              <p className="mt-2 font-medium text-blue-600">Board Certified in Internal Medicine & Obesity Medicine</p>
            </div>
          </div>

          {/* Dr. Anugeet's Card */}
          <div className="text-center">
            <div className="relative">
              <img
                className="mx-auto h-64 w-64 rounded-full object-cover"
                src="/AnuDoctor.jpg"
                alt="Dr. Anugeet"
              />
            </div>
            <div className="mt-6">
              <h3 className="text-xl font-medium text-gray-900">Dr. Anugeet Kaur MD</h3>
              <p className="mt-2 font-medium text-blue-600">Board Certified in Family Medicine & Obesity Medicine</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}